import React, { useEffect, useState } from 'react';
import Branch from '../../components/Branch';
import { useNavigate, useParams } from 'react-router-dom';
import Loader from '../../components/Loader';
import { api } from '../../app/Api/ApiSlice';
import { toast } from 'react-toastify';
import './orgStyle.css';
import { FaPlus } from 'react-icons/fa';
import OrgBranchAdminCard from '../../components/OrgBranchAdminCard';

const BranchesAccepted = () => {
    const { organization } = useParams();
    
    const [orgBranches, setOrgBranches] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [branchesTitle, setBranchesTitle] = useState("");

    const navigate = useNavigate()

    useEffect(() => {
        const getBranches = async () => {
            try {
                setIsLoading(true);
                const response = await api.get(`/${organization}/branches`);
                setOrgBranches(response.data?.branches.organizations || []);
                setBranchesTitle(response.data?.branches.title);
            } catch (error) {
                const message =
                    error?.response?.data?.message || 'Failed to fetch branches';
                toast.error(message);
            } finally {
                setIsLoading(false);
            }
        };

        if (organization) {
            getBranches();
        }
    }, [organization]);

    // console.log("org_branches:",orgBranches)

    return (
        <div className="org-branches">
            <div className="orglist-page-header">
                <h2 className=''>{organization} </h2>
            </div>
            <h2 className='page-title'>Branches</h2>
            {isLoading && <Loader />}

            {!isLoading && orgBranches.length === 0 && (
                <p className="not-found-msg">No branches found</p>
            )}

            {orgBranches?.length > 0 &&
                orgBranches.map((branch) => (
                    <OrgBranchAdminCard branch={branch} />
                ))}
        </div>
    );
};

export default BranchesAccepted;
